import instantsearch from 'instantsearch.js';
import searchResult from '../templates/search-result';
import searchStats from '../templates/search-stats';
import searchEmpty from '../templates/search-empty';

const Search = class {

    constructor(formElement) {

        this.$formElement = $(formElement);

        if (this.$formElement.length < 1) {
            return;
        }

        this.instantsearch = instantsearch({
            appId: this.$formElement.data('applicationId'),
            apiKey: this.$formElement.data('searchApiKey'),
            indexName: this.$formElement.data('index'),
            urlSync: true
        });

        this.setupWidgets();
        this.start();

        this.instantsearch.on('render', () => {
            const query = this.instantsearch.helper.getQueryParameter('query');
            dataLayer.push({
                event: 'search',
                query,
            });
        });

    }

    setupWidgets() {

        this.instantsearch.addWidget(
            instantsearch.widgets.searchBox({
                container: '#search-box',
                placeholder: 'What are you looking for?',
                autofocus: true,
                searchOnEnterKeyPressOnly: false,
                cssClasses: {
                    root: 'search-box',
                    input: 'search-box__input',
                },
            })
        );

        this.instantsearch.addWidget(
            instantsearch.widgets.stats({
                container: '#search-stats',
                templates: {
                    header: '<h1>Search Results</h1>',
                    body: searchStats,
                },
            })
        );

        this.instantsearch.addWidget(
            instantsearch.widgets.hits({
                container: '#search-hits',
                templates: {
                    empty: searchEmpty,
                    item: searchResult,
                },
                hitsPerPage: 15,
                transformData: {
                    item(item) {

                        switch (item.type) {
                        case 'newsArticle':
                            item.type = 'article';
                            break;
                        case 'company':
                            item.type = 'insurer';
                            break;
                        case 'product':
                            item.type = 'policy';
                            break;
                        case 'term':
                            item.type = 'glossary';
                            break;
                        case 'question':
                            item.type = 'faq';
                            break;
                        case 'tools':
                            item.type = 'tool';
                            item.isTool = true;
                            break;
                        default:
                            item.type = false;
                            break;
                        }

                        if (item.primaryImages && item.primaryImages.length) {
                            item.primaryImage = item.primaryImages[0];
                        }

                        return item;
                    },
                },
            })
        );

        this.instantsearch.addWidget(
            instantsearch.widgets.pagination({
                container: '#search-pagination',
                scrollTo: true,
                showFirstLast: false,
                padding: 2,
                labels: {
                    previous: '<svg class="icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#chevron-left-small"></use></svg>',
                    next: '<svg class="icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#chevron-right-small"></use></svg>',
                },
                cssClasses: {
                    root: 'nav pagination',
                    previous: 'pagination__previous',
                    next: 'pagination__next',
                    item: 'pagination__item',
                    page: 'pagination__page',
                    link: 'pagination__link',
                    active: 'is-active',
                    disabled: 'is-disabled',
                },
            })
        );

    }

    start() {
        this.instantsearch.start();
    }

};

new Search('.js-search-form');
